export default __webpack_public_path__ + "static/banner-what-type-of-wedding-are-you-9f3305a1128f8e4100db8ac896da9d31.jpg";